<div class="nav-web d-sm-none d-md-none d-lg-block tablet-hide">
  <nav class="navbar navbar-expand-lg justify-content-between border-bottom">
    <div class="d-flex justify-content-between align-items-center">
      <div class="bar-header" style="width: 90px" id="id_barheader">
        <img
          routerLink="/"
          class="c-pt"
          style="height: 6.2rem; position: relative; left: -2rem"
          src="assets/images/navigation-menu/Brijjiworks_logo.svg"
        />
      </div>
      <div class="breadcrumbs-section" style="margin-left: -0.5rem">
        <img
          src="assets/images/icons/main-breadcrumb-icon.svg"
          style="cursor: pointer; height: 0.8rem"
        />
        <div class="menu d-flex align-items-center">
          <ul class="ps-0 mb-0 list-unstyled d-flex">
            <li
              *ngFor="let crumb of breadcrumbs$ | async; let isLast = last"
              class="breadcrumb-item mb-0"
            >
              <a [ngClass]="{ active: isLast }" class="breadcrumb-link">
                {{ crumb }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <div class="d-flex align-items-center gap-2 me-3">
        <div class="image-wrapper">
          <img src="assets/images/icons/warehouse_dark_icon.svg" alt="" class="warehouse-icon" />
        </div>
        <div class="warehouse-name d-flex flex-column justify-content-between ms-2">
          <div class="first-section" style="min-height: 22px">Warehouse</div>
          <div class="second-section">
            {{ selectedWarehouseName }}
          </div>
        </div>
      </div>
      <div class="bell-wrapper dropdown">
        <button
          type="button"
          id="dropdownMenuButton22"
          data-bs-toggle="dropdown"
          aria-expanded="true"
        >
          <img width="20px" height="20px" src="assets/images/icons/dots.svg" />
        </button>

        <div class="dropdown-menu custom-dropdown" aria-labelledby="dropdownMenuButton22">
          <div class="icon-grid">
            <div
              class="icon-item"
              *ngIf="userInfo?.isTpmPresent == true"
              (click)="userInfo.isTpmPresent ? redirectToModule(1) : ''"
              (contextmenu)="onRightClick($event, 1)"
            >
              <img src="assets/images/icons/tpmiconadduser.svg" alt="TPM Icon" />
              <span>TPM</span>
            </div>

            <div
              class="icon-item"
              *ngIf="userInfo?.isPosPresent"
              (click)="userInfo.isPosPresent ? redirectToModule(2) : ''"
              (contextmenu)="onRightClick($event, 2)"
            >
              <img src="assets/images/icons/posiconadduser.svg" alt="POS Icon" />
              <span>POS</span>
            </div>
            <div
              class="icon-item"
              *ngIf="userInfo?.isCompanyPortalPresent"
              (click)="redirectToModule(6)"
              (contextmenu)="onRightClick($event, 6)"
            >
              <img src="assets/images/icons/newbrijjlogo.svg" alt="Brijj Icon" />
              <span>Company Portal</span>
            </div>
            <div
              class="icon-item"
              *ngIf="userInfo?.isListerPresent"
              (click)="redirectToModule(4)"
              (contextmenu)="onRightClick($event, 4)"
            >
              <img src="assets/images/icons/listerportal.svg" alt="Lister Icon" />
              <span>Lister</span>
            </div>
            <div
              class="icon-item"
              *ngIf="userInfo?.isDonationPresent"
              (click)="redirectToModule(3)"
              (contextmenu)="onRightClick($event, 3)"
            >
              <img src="assets/images/icons/donationlogo.svg" alt="Donation Icon" />
              <span>Donation</span>
            </div>
            <div
              class="icon-item"
              *ngIf="userInfo?.isConsignmentPresent"
              (click)="redirectToModule(8)"
              (contextmenu)="onRightClick($event, 8)"
            >
              <img src="assets/images/icons/ConsignmentLogo.png" alt="Consignment Icon" />
              <span>Consignment</span>
            </div>
          </div>
        </div>
      </div>
      <!-- User Profile Dropdown -->
      <div class="dropdown position-relative" (click)="handleDropdownToggle()">
        <div
          class="user-profile d-flex justify-content-end align-items-center"
          style="cursor: pointer"
          id="dropdownMenuButton2"
          data-bs-toggle="dropdown"
          aria-expanded="true"
        >
          @if (!userInfo.profileImgUrl) {
            <div class="profile-pic" id="demoImg">
              <img src="assets/images/navigation-menu/ic_userSample.svg" id="adminprofileImg" />
            </div>
          } @else {
            <div class="profile-pic" id="demoImg">
              <img [src]="userInfo.profileImgUrl" id="adminprofileImg" />
            </div>
          }
          <div class="username-container">
            @if (!userInfo.displayName) {
              <div class="user-name">{{ userInfo.fullName }}</div>
            } @else {
              <div class="user-name">{{ userInfo.displayName }}</div>
            }
            <div class="view-more position-relative">
              <h6 style="font-size: 12px; color: #999" id="id_userRole">
                {{ roles[0] }}
                <span class="role-hover-group" *ngIf="roles.length > 1">
                  {{ '+' + (roles.length - 1) }}
                  <ul class="show-list">
                    <li
                      style="color: #ffffff; padding-block: 2px"
                      *ngFor="let rl of roles.slice(1)"
                    >
                      {{ rl }}
                    </li>
                  </ul>
                </span>
              </h6>
            </div>
          </div>

          <!-- Dropdown Arrow -->
          <i
            class="fas fa-chevron-down ms-2"
            [ngClass]="{ 'fa-chevron-up': isDropdownOpen, 'fa-chevron-down': !isDropdownOpen }"
          ></i>
        </div>

        <!-- Dropdown Menu -->
        <div
          class="dropdown-menu position-absolute"
          [ngClass]="{ show: isDropdownOpen }"
          style="right: 0px; top: 105%; left: auto; min-width: 200px"
        >
          <a
            class="dropdown-item px-2 py-2"
            data-bs-toggle="modal"
            data-bs-target="#SelectOutletModal"
            #selectOutlet
          >
            <img
              src="assets/images/icons/switch_warehouse.svg"
              style="width: 24px; height: 24px"
              class="me-1"
              alt=""
            />
            Switch Warehouse
          </a>
          <a
            class="dropdown-item px-3 py-2 text-danger"
            (click)="logout(); $event.preventDefault()"
          >
            <i class="fas fa-sign-out-alt me-2"></i>Logout
          </a>
        </div>
      </div>
    </div>
  </nav>
</div>

<!-- Sidebar + Submenus wrapper -->
<div class="d-flex layout-wrapper" style="height: 90vh">
  <!-- Sidebar + Submenus in same wrapper -->
  <div class="sidebar-container d-flex" #menuWrapper>
    <!-- Sidebar -->
    <div class="sidebar border-end">
      <div class="menu w-100 h-100">
        <ul class="list-unstyled">
          <li *ngFor="let menu of menuItems">
            <a class="d-flex justify-content-center" (click)="onMenuClick(menu, $event)">
              <img
                class="menu-icon"
                [ngClass]="isMenuActive(menu) ? 'active-style' : 'inactive-style'"
                [src]="isMenuActive(menu) ? menu.activeIcon : menu.inactiveIcon"
                alt="{{ menu.title }} Icon"
              />
            </a>
            <span class="menutitle">{{ menu.title }}</span>
          </li>
        </ul>
      </div>
    </div>

    <!-- Submenus -->
    <div
      class="submenus p-3 border-end submenu-transition"
      *ngIf="selectedMenu && getSubmenu(selectedMenu).length > 0"
    >
      <div class="submenu">
        <div class="submenu-title">{{ selectedMenu }}</div>
        <div class="divider"></div>
      </div>
      <ul class="submenu-list list-unstyled">
        <li *ngFor="let item of getSubmenu(selectedMenu)" class="submenu-item">
          <a
            [routerLink]="item.route"
            routerLinkActive="subActive"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            {{ item.title }}
          </a>
        </li>
      </ul>
    </div>
  </div>

  <!-- Main Content -->
  <div id="content">
    <div class="main-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<div
  *ngIf="showContextMenu"
  [ngStyle]="{ top: contextMenuPosition.y, left: contextMenuPosition.x }"
  class="custom-context-menu"
  (click)="openInNewTab()"
>
  Open in new tab
</div>
<div
  class="modal fade"
  id="SelectOutletModal"
  aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel"
  tabindex="-1"
  data-bs-backdrop="static"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="custom-modal-header py-0 modal-header">
        <h5 class="mb-0 border-0">Switch Warehouse</h5>
      </div>
      <div class="custom-modal-body modal-body">
        <div class="modal-body-wraapper">
          <div class="enter mb-3">
            <label for="name" class="form-label" id="lbl-OutletS">Warehouses</label>
            <select
              class="form-select border"
              aria-label="Default select example"
              [(ngModel)]="selectedWarehouseId"
            >
              <option [ngValue]="0" hidden>Select warehouse</option>
              <option *ngFor="let item of warehouses" [ngValue]="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="radio-btn">
          <input
            class="form-check-input"
            type="checkbox"
            id="preference"
            [checked]="isDefault"
            (click)="toggleDefaultPreferrence()"
          />
          <label for="preference">Save my preference</label>
        </div>
      </div>
      <div class="custom-modal-footer modal-footer pt-0">
        <button
          class="btn modal-btn text-nowrap"
          data-bs-dismiss="modal"
          aria-label="Close"
          [hidden]="selectedWarehouseId == 0"
          (click)="SaveWarehouse()"
          id="btn-Continue"
        >
          Continue
        </button>
        <button
          class="btn modal-btn text-nowrap"
          id="btn-continuepos"
          [hidden]="selectedWarehouseId > 0"
          style="background-color: #d4d4d4; color: white; border-color: #d4d4d4"
          disabled
        >
          Continue
        </button>
      </div>
    </div>
  </div>
</div>
